import "@/App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import PhotoReel from "./components/PhotoReel";
import WhyChooseUs from "./components/WhyChooseUs";
import HowItWorks from "./components/HowItWorks";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import MobileCallBar from "./components/MobileCallBar";

function App() {
    return (
        <div className="App font-body" data-testid="landing-page-root">
            <Header />
            <main>
                <Hero />
                <Services />
                <PhotoReel />
                <WhyChooseUs />
                <HowItWorks />
                <Testimonials />
                <Contact />
            </main>
            <Footer />
            <MobileCallBar />
        </div>
    );
}

export default App;
